import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../store";

const MoreScoreFactorDialog = (props: any) => {
    const isBankrupt = props.reportObject?.businessCompanyReport?.credit_score_and_limit?.current_score === "0" ? true : false;
    const businessProfileStatus = useSelector(
        (state: ApplicationState) =>
            state.loggedInUser &&
            state.loggedInUser.userServiceDetails?.businessProfileStatus?.filter((obj: any) => {
                return obj.provider;
            })
    );
    const creditProvider = businessProfileStatus != null && businessProfileStatus.length > 0 ? businessProfileStatus[0].provider : "";
    useEffect(() => {
        window.addEventListener("keyup", (evt: any) => {
            evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = evt.key === "Escape" || evt.key === "Esc";
            } else {
                isEscape = evt.keyCode === 27;
            }
            if (isEscape) {
                props.closeDialog("cancel");
            }
        });
        return () => {
            window.removeEventListener("keyup", () => {});
        };
    });

    const CloseDialog = () => {
        props.closeDialog("close");
    };

    return (
        <React.Fragment>
            <div className="dialog-header">
                <div className="dialog-icon">
                    <em className="lar la-star"></em>
                </div>
                <h1>Business Credit Rating</h1>
            </div>
            <div className="dialog-body">
                <p>
                    The {creditProvider === "CREDITSAFE" ? "Creditsafe" : "Dun & Bradstreet"} Rating works on a scale of{" "}
                    {creditProvider === "CREDITSAFE" ? "1-100" : "1-5"} and predicts the likelihood that a business's payment performance will become seriously
                    delinquent, defined as 90-plus days beyond terms, within the next 12 months or that the business will go bankrupt.
                </p>
                {creditProvider !== "CREDITSAFE" && (
                    <table className="m-table-generic">
                        <caption>
                            <div className="content-sub-title margin-vertical-xs">Credit Risk Class Definitions</div>
                        </caption>

                        <tbody>
                            <tr>
                                <th scope="col">Class</th>
                                <th scope="col">Risk Rating</th>
                            </tr>
                            {isBankrupt && (
                                <tr>
                                    <td>X</td>
                                    <th scope="row">
                                        <span className="risk-indicator lvl-not-rated-risk-bg"></span>Bankrupt
                                    </th>
                                </tr>
                            )}
                            <tr>
                                <td>5</td>
                                <th scope="row" style={{ width: "200px" }}>
                                    <span className="risk-indicator lvl-very-high-risk-bg"></span>Very High Risk
                                </th>
                            </tr>
                            <tr>
                                <td>4</td>
                                <th scope="row">
                                    <span className="risk-indicator lvl-high-risk-bg"></span>High Risk
                                </th>
                            </tr>
                            <tr>
                                <td>3</td>
                                <th scope="row">
                                    <span className="risk-indicator lvl-moderate-risk-bg"></span>Moderate Risk
                                </th>
                            </tr>
                            <tr>
                                <td>2</td>
                                <th scope="row">
                                    <span className="risk-indicator lvl-low-risk-bg"></span>Low Risk
                                </th>
                            </tr>
                            <tr>
                                <td>1</td>
                                <th scope="row">
                                    <span className="risk-indicator lvl-very-low-risk-bg"></span>Very Low Risk
                                </th>
                            </tr>
                        </tbody>
                    </table>
                )}

                {creditProvider !== "CREDITSAFE" && isBankrupt ? (
                    <p>A score of "X" denotes open bankruptcy, out of business at the location, or higher risk situations.</p>
                ) : null}

                {creditProvider === "CREDITSAFE" && (
                    <table className="m-table-generic">
                        <caption>
                            <div className="content-sub-title margin-vertical-xs">Rating Definitions</div>
                        </caption>
                        <thead className="sr-only">
                            <tr>
                                <th scope="col">Score</th>
                                <th scope="col">Rating</th>
                                <th scope="col">Score Range</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th scope="row" style={{ width: "200px" }}>
                                    <span className="risk-indicator lvl-very-low-risk-bg"></span> Very Low Risk
                                </th>
                                <td>Rating = A</td>
                                <td>71 to 100</td>
                            </tr>
                            <tr>
                                <th scope="row">
                                    <span className="risk-indicator lvl-low-risk-bg"></span> Low Risk
                                </th>
                                <td>Rating = B</td>
                                <td>51 to 70</td>
                            </tr>
                            <tr>
                                <th scope="row">
                                    <span className="risk-indicator lvl-moderate-risk-bg"></span> Moderate Risk
                                </th>
                                <td>Rating = C</td>
                                <td>30 to 50</td>
                            </tr>
                            <tr>
                                <th scope="row">
                                    <span className="risk-indicator lvl-high-risk-bg"></span> High Risk
                                </th>
                                <td>Rating = D</td>
                                <td>21 to 29</td>
                            </tr>
                            <tr>
                                <th scope="row">
                                    <span className="risk-indicator lvl-very-high-risk-bg"></span> Very High Risk
                                </th>
                                <td>Rating = D/E</td>
                                <td>0 to 20</td>
                            </tr>
                            <tr>
                                <th scope="row">
                                    <span className="risk-indicator lvl-not-rated-risk-bg"></span> Not Rated
                                </th>
                                <td colSpan={2}>
                                    Due to limited trade line/payment data on your business record, there is insufficient information to determine an appropriate
                                    credit rating at this time.
                                </td>
                            </tr>
                        </tbody>
                    </table>
                )}
            </div>
            <div className="dialog-footer">
                <div className="row between-xs">
                    <div className="col-xs col-no-gutter flex-grow-null"></div>
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button type="button" className="btn-default btn-red" onClick={() => CloseDialog()}>
                            <span className="btn-text">Close</span>
                        </button>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};
export default MoreScoreFactorDialog;
